export const MODULE_IDS = Object.freeze({
  FRONTDESK: "frontdesk",
  BILLING: "billing",
  PHARMACY: "pharmacy",
  INVENTORY: "inventory",
  IN_PATIENT: "in-patient",
  OUT_PATIENT: "out-patient",
  LABORATORY: "laboratory",
  REPORT: "report",
  SUBSCRIPTIONS: "subscriptions",
});

export const SETTINGS_ACCESS = Object.freeze({
  hospitalSetup: ["manage-organization", "super-view"],
  branches: ["view-branch", "manage-organization", "super-view"],
  branchConfig: ["view-branch", "manage-organization", "super-view"],
  departments: ["view-department", "manage-department", "super-view"],
  staff: ["view-staff", "manage-staff", "super-view"],
  roles: ["get-role", "manage-role", "super-view"],
  sponsors: ["view-sponsor", "manage-sponsor", "super-view"],
  patients: ["view-patient", "manage-patient", "super-view"],
  plans: ["view-plan", "manage-plan", "super-view"],
  banks: ["view-bank", "manage-bank", "super-view"],
  categories: ["view-category", "manage-category", "super-view"],
  forms: ["view-form", "manage-form", "super-view"],
  discounts: ["view-discount", "manage-discount", "super-view"],
  admissionManagement: ["view-admission", "manage-admission", "super-view"],
  schedules: ["view-shift", "manage-shift", "super-view"],
  dataLibrary: ["view-dropdown", "manage-dropdown", "super-view"],
  partnership: ["manage-partnership", "super-view"],
  integrations: ["manage-integrations", "super-view"],
  registrationCustomization: ["edit-organization", "manage-organization", "super-edit"],
  bulkUploads: ["super-view", "super-create"],
  license: ["view-staff", "manage-staff", "super-view"],
  centralConfig: ["manage-item", "manage-stock", "super-view"],
  dashboards: ["super-view"],
});

export const AUDIT_TRAIL_ACCESS = Object.freeze(["view-audit-trail", "super-view"]);
export const REPORT_ACCESS = Object.freeze(["view-report", "super-view"]);
export const CENTRAL_STORE_ACCESS = Object.freeze(["view-item", "manage-item", "view-stock", "manage-stock", "super-view"]);
export const SUBSCRIPTIONS_ACCESS = Object.freeze([
  "view-subscription",
  "purchase-subscription",
  "manage-subscription",
  "super-view",
]);
export const SETTINGS_ADMIN_ACCESS = Object.freeze([...new Set(Object.values(SETTINGS_ACCESS).flat())]);

export const SETTINGS_ROUTE_ACCESS = Object.freeze([
  { path: "hospital-setup", permissions: SETTINGS_ACCESS.hospitalSetup },
  { path: "branches", permissions: SETTINGS_ACCESS.branches },
  { path: "departments", permissions: SETTINGS_ACCESS.departments },
  { path: "staff", permissions: SETTINGS_ACCESS.staff },
  { path: "roles", permissions: SETTINGS_ACCESS.roles },
  { path: "sponsors", permissions: SETTINGS_ACCESS.sponsors },
  { path: "patients", permissions: SETTINGS_ACCESS.patients },
  { path: "plans", permissions: SETTINGS_ACCESS.plans },
  { path: "banks", permissions: SETTINGS_ACCESS.banks },
  { path: "categories", permissions: SETTINGS_ACCESS.categories },
  { path: "forms", permissions: SETTINGS_ACCESS.forms },
  { path: "discount", permissions: SETTINGS_ACCESS.discounts },
  { path: "admission-mgt", permissions: SETTINGS_ACCESS.admissionManagement },
  { path: "schedules", permissions: SETTINGS_ACCESS.schedules },
  { path: "data-library", permissions: SETTINGS_ACCESS.dataLibrary },
  { path: "reg-custom", permissions: SETTINGS_ACCESS.registrationCustomization },
  { path: "bulk-uploads", permissions: SETTINGS_ACCESS.bulkUploads },
  { path: "license", permissions: SETTINGS_ACCESS.license },
  { path: "central-config", permissions: SETTINGS_ACCESS.centralConfig },
]);

export const hasAnyPermission = (grantedPermissions = [], requiredPermissions = []) =>
  requiredPermissions.some((permission) => grantedPermissions.includes(permission));

export const hasAnySettingsAccess = (grantedPermissions = []) =>
  Object.values(SETTINGS_ACCESS).some((requiredPermissions) => hasAnyPermission(grantedPermissions, requiredPermissions));

export const getFirstAccessibleSettingsPath = (grantedPermissions = []) =>
  SETTINGS_ROUTE_ACCESS.find(({ permissions }) => hasAnyPermission(grantedPermissions, permissions))?.path || null;
